exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/shoes-detail/shoes-detail.component.css
// module id = ../../../../../src/app/shoes-detail/shoes-detail.component.css
// module chunks = main